import * as types from './mutation-types';

export const setMessages = ({ commit }, messages) => {
  commit(types.SET_MESSAGES, messages);
};

export const resetMessages = ({ commit }) => {
  commit(types.RESET_MESSAGES);
};

export default {
  setMessages,
  resetMessages,
};



// WEBPACK FOOTER //
// ./src/store/modules/general/actions.js